import Block from './Block'

export default class Filter extends Block {
  getElems() {
    this.filters = this.el.querySelectorAll('.filter > select')
    this.button = this.el.querySelector('.filters__button')
  }

  events() {
    this.button.addEventListener('click', this.onButtonClick.bind(this))
  }

  onButtonClick() {
    const url = new URL(window.location.origin + this.button.dataset.url)

    if (this.filters.length === 1 && this.filters[0].name === 'category') {
      url.pathname = this.filters[0].value
    } else {
      this.filters.forEach((filter) => {
        filter.value && url.searchParams.append(filter.name, filter.value)
      })
    }

    window.location.href = url.href
  }
}
